export default "images/roadIcon.png";